import { useQuery } from 'react-query';
import { smartbizUrl } from '../ApiClient';
import { Endpoints } from '../../enums/Endpoints';

export async function getChatBotJWT() {
  const response = (
    await smartbizUrl.get(`${Endpoints.getJwtToken}`)
  )?.data;
  return response;
}
  
  const useGetChatBotJWTQuery = () => {
    const { isLoading, error, data } = useQuery('chatBotJwtToken', getChatBotJWT);
  
    return { isLoading, error, data };
  }
  
  export default useGetChatBotJWTQuery;